<ion-row>
  <ion-col *ngIf="valgtTimeAnlegg && valgtAvtale && _chartTypes.Time.active">
    <!-- Time -->
    <app-kostnadstall-hour
      [valgtAnlegg]="valgtTimeAnlegg"
      [selectedDate]="selectedDateHour"
      [valgtAvtale]="valgtAvtale"
      [_foretakMap]="_foretakMap"
      [isStromstotteToggled]="isStromstotteToggled"
    ></app-kostnadstall-hour>
  </ion-col>
  <ion-col *ngIf="valgtDagAnlegg && valgtAvtale && _chartTypes.Dag.active">
    <!-- Dag -->
    <app-kostnadstall-day
      [valgtAnlegg]="valgtDagAnlegg"
      [valgtAvtale]="valgtAvtale"
      [_foretakMap]="_foretakMap"
      [selectedDate]="selectedDate"
      [isStromstotteToggled]="isStromstotteToggled"
    ></app-kostnadstall-day>
  </ion-col>
  <ion-col *ngIf="valgtAnleggMaaned && _chartTypes.Maaned.active">
    <!-- Måned -->
    <app-kostnadstall-month
      [valgtAnleggMaaned]="valgtAnleggMaaned"
      [selectedDate]="selectedDateMonth"
    ></app-kostnadstall-month>
  </ion-col>
  <ion-col *ngIf="valgtAnleggAar && _chartTypes.Aar.active">
    <!-- År -->
    <app-kostnadstall-year
      [valgtAnleggAar]="valgtAnleggAar"
    ></app-kostnadstall-year>
  </ion-col>
</ion-row>
